module.exports = __webpack_public_path__ + "img/warning.1e605b84.svg";